import { useMemo, useState } from 'react'
import { UnknownQuestionModel } from '../types'
import { unansweredQuestionTypeLabels } from '../configs'

export const useUnknownQuestionsOptions = (question: UnknownQuestionModel) => {
    const [currentValue, setCurrentValue] = useState(question.type)

    const updateValue = (value: string) => {
        setCurrentValue(value)
    }

    const currentOption = useMemo(() => {
        const label = unansweredQuestionTypeLabels[currentValue] || currentValue
        return { value: currentValue, label: label }
    }, [currentValue])

    return { currentValue, updateValue, currentOption }
}
